import { useCallback } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { shopSlice } from "../_redux/shopSlice";

const { actions } = shopSlice;

export const useShopCart = ({ cartName }) => {
  const dispatch = useDispatch();

  const { cart, sconto } = useSelector(
    (state) => ({
      cart: state.shop[`${cartName}Cart`],
      sconto: state.shop[`${cartName}CartSconto`],
    }),
    shallowEqual
  );

  const getCartValue = useCallback(
    (id) => {
      const value = cart?.[id];
      if (typeof value === "undefined") return 0;
      return value;
    },
    [cart]
  );

  const setCartValue = useCallback(
    (id, value) => {
      let next = value;
      if (next < 0) next = 0;
      dispatch(actions.setCartQuantity({ id, newQuantity: next, cartName }));
    },
    [dispatch, cartName]
  );

  const setScontoValue = useCallback(
    (id, value) => {
      let next = value;
      if (next < 0) next = 0;
      dispatch(actions.setCartSconto({ id, newSconto: next, cartName }));
    },
    [dispatch, cartName]
  );

  const resetCart = useCallback(() => dispatch(actions.resetCart({ cartName })), [dispatch, cartName]);

  return { cart: cart || {}, sconto: sconto || {}, getCartValue, setCartValue, setScontoValue, resetCart };
};

